module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf5.6f9266ad.png";